
export default {
  props: {
    title: { type: String, default: '' },
    text: { type: String, default: '' },
    alignment: { type: String, default: 'right-start' },
  },
};
